<template>
  <b-row class="match-height justify-content-center">
    <b-col sm="12">
      <b-card
        v-if="shortcodes.length"
        no-body
        class="card-company-table"
      >
        <b-table
          v-if="view === 1"
          :items="shortcodes"
          :per-page="pagination.perPage"
          :current-page="pagination.currentPage"
          responsive
          striped
          hover
          :fields="fields"
          class="mb-0"
        >
          <template #cell(label)="data">
            <div class="d-flex align-items-center primary">
              <span class="text-primary" @click="copy(data.item.shortcode_url)"
                    v-b-tooltip.hover.top="'Copy URL'"
              >{{ data.item.label }}</span>
              <i class="feather icon-copy text-danger" @click="copy(data.item.shortcode_url)"
                 style="margin-left: 8px"
              />
            </div>
          </template>

          <template #cell(shortcode_url)="data">
            <div class="d-flex align-items-center primary">
              <span class="text-primary" @click="openLink(data.item.shortcode_url)"
                    v-b-tooltip.hover.top="'Open URL'"
              >{{ data.item.shortcode_url }}</span>
              <i class="feather icon-link text-danger" @click="openLink(data.item.shortcode_url)"
                 style="margin-left: 8px"
              />
            </div>
          </template>

          <template #cell(nb_visits)="data">
            {{ numeralFormat(data.item.nb_visits) }}
          </template>
        </b-table>
        <b-pagination v-if="view === 1"
          v-model="pagination.currentPage"
          :total-rows="pagination.totalRows"
          :per-page="pagination.perPage"
          align="center"
          size="sm"
          class="my-1"
        />
        <g-chart :data="data_chart" :options="options" type="PieChart" v-if="view === 2"/>
        <g-chart :data="data_chart" :options="options" type="BarChart" v-if="view === 3"/>
        <div class="flex flex-row mb-1">
          <b-avatar v-if="view !== 1" class="ml-1 cursor-pointer" variant="light-primary"
                    size="32" @click.native="change_view(1)"
          >
            <mdicon name="table" size="20"/>
          </b-avatar>
          <b-avatar v-if="view !== 2" class="ml-1 cursor-pointer" variant="light-primary"
                    size="32" @click.native="change_view(2)"
          >
            <mdicon name="chart-pie" size="20"/>
          </b-avatar>
          <b-avatar v-if="view !== 3" @click.native="change_view(3)"
                    class="ml-1 cursor-pointer" variant="light-primary" size="32"
          >
            <mdicon name="chart-bar" size="20"/>
          </b-avatar>
        </div>
      </b-card>
      <b-card v-if="shortcodes.length===0 && ready">
        <b-alert
          v-height-fade.appear
          variant="danger"
          show
          class="mb-0"
        >
          <div class="alert-body">
            <feather-icon icon="AlertTriangleIcon" size="20" class="align-text-top"/>
            Link Shortener | There is no data for the selected period
          </div>
        </b-alert>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { GChart } from 'vue-google-charts/legacy'
import numeral from 'numeral'
import store from '@/store'
import api from '@/libs/axios'
import { format } from 'date-fns'
import { hmError, hmSuccess } from '@/libs/toastification'
import emitter from '@core/utils/emitter'

export default {
  components: {
    GChart
  },
  data() {
    return {
      fields: [
        {
          key: 'label',
          label: 'SHORTCODE'
        },
        {
          key: 'shortcode_url',
          label: 'TARGET URL'
        },
        {
          key: 'nb_visits',
          label: 'CLICKS',
          class: 'text-right'
        }
      ],
      shortcodes: [],
      pagination: {
        currentPage: 1,
        totalRows: 1,
        perPage: 10
      },
      options: {
        title: 'Shortcode',
        pieSliceText: 'value-and-percentage',
        width: '100%',
        height: 450,
        pieHole: 0.4,
        legend: {
          position: 'top',
          maxLines: 3
        }
      },
      view: null,
      ready: false
    }
  },
  computed: {
    data_chart() {
      const result = [['SHORTCODE', 'CLICKS']]
      for (const el of this.shortcodes) {
        result.push([el.label, el.nb_visits])
      }
      return result
    }
  },
  methods: {
    getExternalShortcodeUsageReport() {
      if (!store.state.app.idsite) return
      api.post('/api/matomo/shortcodes', {
        idSite: store.state.app.idsite,
        startDate: format(store.state.app.range.startDate, 'yyyy-MM-dd'),
        endDate: format(store.state.app.range.endDate, 'yyyy-MM-dd'),
        period: store.state.app.period
      })
        .then(r => {
          if (r.data.code !== 'Ok') return hmError('Error reading data')
          this.shortcodes = r.data.channels
          this.pagination.totalRows = this.shortcodes.length
          this.ready = true
        })
    },
    numeralFormat(value, format = '0,0') {
      return numeral(value)
        .format(format)
    },
    copy(url) {
      this.$copyText(url)
        .then(() => hmSuccess('URL copied'))
    },
    openLink(link) {
      window.open(link, '_blank')
    },
    change_view(v) {
      this.view = v
      localStorage.setItem('shortcode_view', v)
    }
  },
  mounted() {
    this.view = parseInt(localStorage.getItem('shortcode_view') || 1, 10)
    this.getExternalShortcodeUsageReport()
    emitter.on('change_calendar', this.getExternalShortcodeUsageReport)
    emitter.on('change_site', this.getExternalShortcodeUsageReport)
  },
  beforeDestroy() {
    emitter.off('change_calendar', this.getExternalShortcodeUsageReport)
    emitter.off('change_site', this.getExternalShortcodeUsageReport)
  }
}
</script>
